import app from 'flarum/forum/app';
import CookieConsentBanner from './components/CookieConsentBanner';
import CookieConsentService from './service/cookieConsent';
export { default as extend } from './extend';
app.initializers.add('devconnect-legal-cookie-consent', () => {
  app.beforeMount(() => {
    if (app.forum.attribute('devconnectLegalCookieConsentEnabled') === false) return;
    const version = app.forum.attribute('devconnectLegalCookieVersion') || '2026-08-08';
    const service = new CookieConsentService(document, version);

    // Монтирование откладывается до создания штатных контейнеров Flarum и не вмешивается в маршрутизацию приложения.
    queueMicrotask(() => {
      let container = document.getElementById('devconnect-cookie-consent');
      if (!container) {
        container = document.createElement('div');
        container.id = 'devconnect-cookie-consent';
        document.body.appendChild(container);
      }
      m.mount(container, {
        view: () => m(CookieConsentBanner, {
          service
        })
      });
    });

    // Делегирование поддерживает SSR-футер при переходах SPA и не создаёт повторные обработчики для каждой страницы.
    document.addEventListener('click', event => {
      const trigger = event.target.closest?.('[data-dc-cookie-settings]');
      if (trigger) {
        event.preventDefault();
        service.reopen();
      }
    });
  });
});